import { Button } from "@govlaunch/core";
import * as palette from "@govlaunch/palette";
import React from "react";
// eslint-disable-next-line
// @ts-ignore
import { IntercomAPI } from "react-intercom";
import MakersIcon from "~/components/icons/MakersIcon";
import mediaQueries from "~/lib/utils/mediaQueries";
import { FormattedMessage } from "react-intl";
import Strongify from "~/lib/utils/strongify";

export default function UpgradeSuccess() {
  return (
    <div
      css={mediaQueries({
        position: "relative",
        display: "grid",
        gridRowGap: 20,
        alignItems: "center",
        padding: 50,
        textAlign: "center",
        background: palette.white,
        border: `solid 1px #e4e4e4`,
        borderRadius: 4,
        "> p": {
          color: "#212121",
          fontSize: [16, 16, 18, 23],
          lineHeight: 1.33,
        },
      })}
    >
      <div
        css={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "calc(100% - 200px)",
          backgroundImage: `url("/static/makers/confetti.png")`,
          backgroundPosition: "center",
        }}
      />

      <div>
        <MakersIcon width={59} height={59} />
      </div>

      <h1
        css={mediaQueries({
          margin: 0,
          fontSize: [23, 23, 26, 36],
          color: "#212121",
        })}
      >
        <FormattedMessage defaultMessage="Upgrade Successful" id="c3JbkI" />
      </h1>

      <p>
        <FormattedMessage
          defaultMessage="Congratulations and welcome to the <strong>Makers</strong> community!"
          id="pwO0XI"
          values={{ strong: (chunk: any) => Strongify(chunk) }}
        />
      </p>

      <p>
        <FormattedMessage defaultMessage="Click below to get started with your upgraded account 👇" id="bsegy1" />
      </p>

      <div
        css={mediaQueries({
          height: [240, 240, 240, 322],
          marginRight: -50,
          marginLeft: -50,
          backgroundImage: `url("/static/makers/upgrade-success.png")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
        })}
      />

      <div
        css={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          color="#25c088"
          textColor={palette.white}
          onClick={() => {
            if (IntercomAPI && typeof IntercomAPI === "function") {
              // TODO: make sure this is the correct tour ID
              IntercomAPI("startTour", "2219251");
            }
          }}
        >
          <strong
            css={{
              fontSize: 19,
            }}
          >
            <FormattedMessage defaultMessage="Take Tour" id="Dl3VDT" />
          </strong>
        </Button>
      </div>
    </div>
  );
}
